// Exports
export * from './LeadDisable';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/Disable/index.ts